var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectUser = function SvgSelectUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9829 6.00001L15.9762 6L15.9696 6.00001C12.13 6.00692 10.4375 8.99409 11.0327 12.5236C11.6274 16.0501 13.774 17.9523 15.9696 17.96L15.9762 17.96L15.9829 17.96C18.1785 17.9523 20.325 16.0501 20.9198 12.5236C21.515 8.99409 19.8225 6.00692 15.9829 6.00001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM5.80593 24.0681C6.88932 22.661 10.6739 20.2206 13.3074 18.6179C14.1189 19.0829 15.0216 19.3366 15.9763 19.34C16.9309 19.3366 17.8337 19.0829 18.6451 18.6179C21.2978 20.2322 25.1183 22.6966 26.1698 24.0986C27.9412 21.8771 29 19.0622 29 16C29 8.8203 23.1797 3 16 3C8.8203 3 3 8.8203 3 16C3 19.0482 4.0491 21.8514 5.80593 24.0681Z",
    fill: "currentColor"
  })));
};
export default SvgSelectUser;